<template>
  <div class="ibox deployment-theme">
    <div class="ibox-title">
      <h2>{{ $t('cms.deployment.theme.title') }}</h2>
    </div>
    <div :class="'ibox-content p-md' + (listLoading ? ' sk-loading' : '')">

      <div v-if="listLoading" class="sk-spinner sk-spinner-double-bounce">
          <div class="sk-double-bounce1"></div>
          <div class="sk-double-bounce2"></div>
      </div>

      <p>{{ $t('cms.deployment.theme.note') }}</p>

      <form role="form" @submit="onFormSubmit" name="publish-theme">
        <button class="btn btn-primary ladda-button publish-theme" data-style="zoom-in" type="submit">{{$t('cms.deployment.theme.button')}}</button>
      </form>

    </div>
  </div>
</template>

<script lang="ts">
import { Ref, defineComponent, PropType, computed, onMounted, onBeforeUnmount, ref, watch, reactive } from '@fwk-node-modules/vue'
import { getApp, useRouter, useStore } from '@fwk-client/utils/vue-3-migration';
import * as api from '@fwk-client/utils/api';
import * as Ladda from 'ladda';

import { useSiteAdmin } from '../../../composables/useSiteAdmin';

export default defineComponent({
    props: {
        
    },
    components: {
    },
    setup(props, context) {
      const app = getApp();
      const $router = useRouter();
      const $store = useStore();
      const { selectedSite } = useSiteAdmin(props, context);


      const listLoading:Ref<boolean> = ref(false);

      var laddaSubmit:Ladda.LaddaButton|null = null;

      onMounted(() => {
        var submitButton:HTMLButtonElement|null = document.querySelector( 'form[name=publish-theme] button.publish-theme' );
        laddaSubmit = Ladda.create(submitButton!);
      })

      const onFormSubmit = (evt:Event) => {
        // We prevent submit of the page
        evt.preventDefault();

        var input = {};

        var options:api.ApiVueOptions =  {
          app: app
        }

        laddaSubmit!.start();

        var path = '/api/admin/cms/site/'+selectedSite.value.site._id+'/deployment/publish-theme';
        
        api.postAPI(path, input, options).then((response:any) => {
          if(response.published && response.site) {  
            // We emit event as user is updated
            context.emit('theme-published', response.site);
          }

          laddaSubmit!.stop();
        });
        
      }

        return { 
          listLoading,
          onFormSubmit
        }
    }
})
</script>